import { Injectable, inject } from '@angular/core';
import { UserDetailDataStore } from './user-detail-data-store.service';
import { assert } from '../../../core/assert/assert';
import { take } from 'rxjs/operators';
import { cloneDeep } from 'lodash-es';
import { UserModel } from '../../../core/models/user/user.model';
import { Subject } from 'rxjs';

// Component Service: This service is solely used for the user module.
@Injectable()
export class UserDataService {
  public userOperationConducted$ = new Subject<boolean>();
  private readonly userDataStore = inject(UserDetailDataStore);

  public addUser(user: UserModel): void {
    assert(user !== null, 'User model is invalid.');
    this.userDataStore.addUser(user);
  }

  public updateUser(user: UserModel): void {
    assert(user !== null, 'User model is invalid.');
    this.userDataStore.updateUser(user);
  }

  public getUserClone(): UserModel | null {
    return cloneDeep(this.getUser());
  }

  private getUser(): UserModel | null {
    let loadedUser: UserModel | null;
    this.userDataStore
      .selectUser()
      .pipe(take(1))
      .subscribe((user) => {
        loadedUser = user;
      });
    return loadedUser;
  }
}
